module.exports = __webpack_public_path__ + "img/allotMusic.8f14d7dd.png";